"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Dialog({ as, className, children, ...rest }) {
    const Component = as ?? "dialog";
    return (_jsx(Component, { className: classNames("cvr-dialog", className), closedby: "any", onBeforeToggle: (event) => {
            if (event.newState === "open") {
                document.body.style.overflow = "hidden";
            }
            else {
                document.body.style.overflow = "";
            }
        }, ...rest, children: children }));
}
export function DialogCloseButton({ children, className, ...rest }) {
    return (_jsx("button", { className: classNames(className, "cvr-dialog-close-button"), "aria-label": "Lukk", ...rest, children: children }));
}
